<div [className]="attachmentType === AttachmentType.Image ? 'attachment' : 'attachment file'">
    <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="attachmentType === AttachmentType.Image">
            <div
                class="attachment__image"
                [pTooltip]="attachment.file.name"
                tooltipPosition="top"
            >
                <img [src]="imageSrc" />
            </div>
        </ng-container>
        <ng-container *ngIf="attachmentType === AttachmentType.File">
            <div class="attachment__file">
                <div class="attachment__file--icon">
                    <img [src]="getItemIconPath()" alt="icon">
                </div>
                <div class="attachment__file--text">
                    <div
                        [pTooltip]="getAttachmentData().name"
                        tooltipPosition="top"
                        class="ellipsis-text line-height-1 mb-1 name"
                    >
                        {{getAttachmentData().name}}
                    </div>
                    <div class="line-height-1 uppercase">
                        {{getAttachmentData().extension}}
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="attachment__btn">
            <i
                class="pi pi-times cursor-pointer"
                (click)="deleteAttachment()"
            ></i>
        </div>
    </ng-container>
    <ng-container *ngIf="isLoading">
        <p-progressSpinner
            class="attachment__spinner"
            styleClass="w-2rem h-2rem"
        />
    </ng-container>
</div>